import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Tooltip, IconButton, useTheme, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { PageHeader } from 'app/components/StyledComponents';
import { BreadcrumbsComponent } from 'app/components/BreadcrumbsComponent';
import { ScorecardProvider } from './context/ScorecardContext';
import { useScorecardPage } from './hooks/useScorecardPage';
import ScorecardContent from './components/ScorecardContent';

function ScorecardPage() {
  return (
    <>
      <Helmet>
        <title>Revenue Operations Scorecard</title>
        <meta name="description" content="Revenue Operations Scorecard - Myautoiq" />
      </Helmet>
      <ScorecardProvider>
        <ScorecardPageContent />
      </ScorecardProvider>
    </>
  );
}

function ScorecardPageContent() {
  const { loading, error, scorecardData } = useScorecardPage();
  const theme = useTheme();

  const breadcrumbsList = scorecardData
    ? [{ label: scorecardData.title, isActive: true }]
    : [{ label: 'Revenue Operations Scorecard', isActive: true }];

  return (
    <Box
      sx={{
        height: 'calc(100vh - 66px)',
        padding: '0 48px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        width: '100%',
      }}
    >
      <Box
        sx={{
          marginTop: '48px',
          marginBottom: '48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '100%',
        }}
      >
        <BreadcrumbsComponent breadcrumbsList={breadcrumbsList} />
        {scorecardData && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0,
              marginTop: '0px',
            }}
          >
            <PageHeader
              sx={{
                marginBottom: '0 !important',
                display: 'inline-block !important',
              }}
            >
              {scorecardData.title}
            </PageHeader>
            <Tooltip
              title={
                <Box>
                  <Typography component="span">{scorecardData.whyItMatters}</Typography>
                </Box>
              }
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: theme.palette.grey[800],
                  fontSize: '0.875rem',
                  padding: '12px',
                  maxWidth: '400px',
                  lineHeight: 1.6,
                },
              },
              arrow: {
                sx: {
                  color: theme.palette.grey[800],
                },
              },
            }}
          >
            <IconButton
              size="small"
              sx={{
                padding: '4px',
                color: theme.palette.primary.main,
                flexShrink: 0,
                marginLeft: '8px',
                marginTop: '2px',
                '&:hover': {
                  backgroundColor: 'rgba(15, 40, 76, 0.08)',
                },
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
        )}
      </Box>

      <Box sx={{ flex: 1, pb: 4 }}>
        <ScorecardContent loading={loading} error={error} data={scorecardData} />
      </Box>
    </Box>
  );
}

export default ScorecardPage;

